/**
 * ASCII で英数の前後にある記号のマップ
 */
export const symbolMap: Record<string, string> = {
  '　': ' ',
  '！': '!',
  '＂': '"',
  '”': '"',
  '＃': '#',
  '＄': '$',
  '％': '%',
  '＆': '&',
  '＇': '\'',
  '’': '\'',
  '（': '(',
  '）': ')',
  '＊': '*',
  '＋': '+',
  '，': ',',
  '－': '-',
  '．': '.',
  '／': '/',
  '：': ':',
  '；': ';',
  '＜': '<',
  '＝': '=',
  '＞': '>',
  '？': '?',
  '＠': '@',
  '［': '[',
  '￥': '\\',
  '］': ']',
  '＾': '^',
  '＿': '_',
  '｀': '`',
  '“': '`',
  '｛': '{',
  '｜': '|',
  '｝': '}',
  '～': '~',
}
